import React from 'react';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { WebformWrapper } from '../../../components';

import './style.scss';

const ParagraphWebform = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const subtitle = entity.getIn(['field_subtitle', 0, 'value']);

  return (
    <Container className="Paragraph ParagraphWebform">
      <div className="row">
        <div className="col-12 col-md-12 col-lg-8 offset-lg-2">

          {title && (
            <h2>{title}</h2>
          )}
          {subtitle && (
            <div className="NodeArticleDetail__subtitle">
              {subtitle}
            </div>
          )}
          <WebformWrapper id={entity.getIn(['field_webform', 0, 'target_id'])} />
        </div>
      </div>
    </Container>
  );
};

export default ParagraphWebform;
